import React, {Component} from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import {Layout} from './hoc/layout';
import Home from './Views/home';
import NewHome from './Views/NewHome';
import SearchResults from './Views/SearchResults';
import Yritysnakyma from './Views/company';
import Header from './components/header';
import NewHeader from './components/NewHeader';
import Footer from './components/footer';
import {IntlProvider} from 'react-intl';
import messages_fi from './static/locales/fi.json';
import messages_sv from './static/locales/sv.json';
import webClient from './api/webClient';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './styles/common.css';
import './styles/typography.css';

const messages = {
  fi: messages_fi,
  sv: messages_sv
};

const setFaviconAndMetadata = lvvEnabled => {
  const faviconName = lvvEnabled ? 'faviconlvv.ico' : 'favicon.ico';
  const descriptionText = lvvEnabled
    ? 'Lupa- ja valvontavirasto ylläpitää rekisteriä perintätoiminnan harjoittajista ja valvoo valtakunnallisesti, että rekisteriin merkityt noudattavat toiminnassaan lakia ja hyvää perintätapaa'
    : 'Etelä-Suomen aluehallintovirasto ylläpitää rekisteriä perintätoiminnan harjoittajista ja valvoo valtakunnallisesti, että rekisteriin merkityt noudattavat toiminnassaan lakia ja hyvää perintätapaa';
  const titleText = lvvEnabled
    ? 'Perintätoimen rekisteri | LVV'
    : 'Perintätoimen rekisteri | Aluehallintovirasto';

  const favicon = document.getElementById('favicon');
  if (favicon) {
    favicon.href = `${process.env.PUBLIC_URL}/${faviconName}`;
  }

  const description = document.getElementById('description');
  if (description) {
    description.content = descriptionText;
  }

  const title = document.getElementById('title');
  if (title) {
    title.textContent = titleText;
  }
};

export default class App extends Component {
  state = {
    languageMessages: messages.fi,
    language: 'fi',
    searchValue: null,
    searchType: null,
    featureFlags: undefined
  };

  componentDidMount() {
    window.document.documentElement.lang = 'fi-FI';

    webClient.get('/FeatureFlags').then(result => {
      this.setState({featureFlags: result.data});
      setFaviconAndMetadata(result.data.LvvEnabled);
    });

    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = e => {
    if (e.ctrlKey && e.altKey && e.shiftKey && e.key.toLowerCase() === 't') {
      webClient
        .post('/FeatureFlags')
        .then(result => {
          this.setState({featureFlags: result.data});
          setFaviconAndMetadata(result.data.LvvEnabled);
        })
        .catch(error => {
          this.setState({featureFlags: null});
          setFaviconAndMetadata(null);
        });
    }
  };

  onLanguageChange = newLang => {
    if (newLang === 'fi-FI') {
      this.setState({languageMessages: messages.fi, language: 'fi'});
      window.document.documentElement.lang = newLang;
    } else if (newLang === 'sv-FI') {
      this.setState({languageMessages: messages.sv, language: 'sv'});
      window.document.documentElement.lang = newLang;
    }
  };

  onSearch = (value, type) => {
    this.setState({searchValue: value, searchType: type});
  };

  render() {
    const {featureFlags} = this.state;

    const lvvEnabled = featureFlags ? featureFlags.LvvEnabled : false;

    return (
      <IntlProvider locale={this.state.language} messages={this.state.languageMessages}>
        <BrowserRouter>
          <div className={lvvEnabled ? 'app-container' : ''}>
            <div className={lvvEnabled ? 'app-content' : 'app_wrapper'}>
              {lvvEnabled ? (
                <NewHeader
                  language={this.state.language}
                  onLanguageChange={this.onLanguageChange}
                  title={document.title}
                  headingLevel="h1"
                  lvvEnabled={lvvEnabled}
                />
              ) : (
                <Header
                  language={this.state.language}
                  onLanguageChange={this.onLanguageChange}
                  title={document.title}
                  headingLevel="h1"
                  lvvEnabled={lvvEnabled}
                />
              )}

              <Layout onSearch={this.onSearch} lvvEnabled={lvvEnabled}>
                <Route
                  path="/"
                  exact
                  render={props => (lvvEnabled ? <NewHome {...props} /> : <Home {...props} />)}
                />
                <Route
                  path="/yritykset"
                  render={props => (
                    <SearchResults
                      {...props}
                      searchValue={this.state.searchValue}
                      searchType={this.state.searchType}
                      locale={this.state.language}
                      lvvEnabled={lvvEnabled}
                    />
                  )}
                />
              </Layout>
              <Route
                path="/yritykset/:id"
                render={props => <Yritysnakyma {...props} lvvEnabled={lvvEnabled} />}
              />
            </div>
            <Footer lvvEnabled={lvvEnabled} />
          </div>
        </BrowserRouter>
      </IntlProvider>
    );
  }
}
